import * as React from "react";
import styled from "styled-components";

import { Button, Text, Textarea } from "../../../../components/atoms";
import { Input, SearchTime } from "../../../../components/molecules";
import { config } from "../../../../config";
import { DatePicker } from "../../../../containers/common/date-picker";
import { SelectorContainer } from "../../../../containers/common/selector";
import { TooltipPopoverContainer } from "../../../../containers/common/tooltip-popover";
import { eventsData } from "../../../../static/events";
import { dateFromIso } from "../../../../utils/dateIso";

interface IProps {
  email: string;
  isShowTooltip: boolean;
  notes: string;
  onDateSelect(date: string): void;
  onEmailChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onEventSelect(event: string): void;
  onNotesChange(e: React.ChangeEvent<HTMLTextAreaElement>): void;
  onSubmit(e: React.FormEvent<HTMLFormElement>): void;
  onTimeSelect(time: string): void;
  selectedDate?: string;
  selectedEvent: string;
  selectedTime: string;
  isFormSent: boolean;
  isFormSentError: boolean;
  isEventDisabled?: boolean;
  isNoHeader?: boolean;
  resetForm(): void;
  resetFormError(): void;
}

const SearchForm = styled.form`
  position: relative;

  > *:not(:first-child) {
    margin-top: 10px;
  }

  > *:last-child {
    margin-top: 0;
  }
`;

const SearchFromEventsDateTimeWrapper = styled.div``;

const SearchFromEventsButton = styled(Button)`
  width: 100%;
  padding: 11px 15px;
  margin-top: 14px;
`;

const SearchFromEventsTooltipWrapper = styled.div`
  padding-top: 10px;

  > div {
    width: 100%;
  }
`;

/**
 * Time range
 */
const startTime = dateFromIso("now").set(config.dateTime.time.start);
const endTime = dateFromIso("now").set(config.dateTime.time.end);
const timeRange: string[] = [];
let iteratedTime = startTime;

while (iteratedTime.valueOf() <= endTime.valueOf()) {
  timeRange.push(iteratedTime.toFormat("h:mm a"));
  iteratedTime = iteratedTime.plus(config.dateTime.time.interval);
}

const SearchFormEvents: React.FC<IProps> = (props) => {
  return props.isFormSent ? (
    <React.Fragment>
      <Text size="16">Your enquiry has been sent successfully.</Text>
      <SearchFromEventsButton background="blue" onClick={props.resetForm}>
        Ok
      </SearchFromEventsButton>
    </React.Fragment>
  ) : props.isFormSentError ? (
    <React.Fragment>
      <Text size="16">Error. Something went wrong.</Text>
      <SearchFromEventsButton background="blue" onClick={props.resetFormError}>
        Try again...
      </SearchFromEventsButton>
    </React.Fragment>
  ) : (
    <SearchForm onSubmit={props.onSubmit} noValidate>
      {props.isNoHeader ? undefined : (
        <Text size="16" align="left">
          Ruuby's team can make the perfect addition to any event you’d like to
          do. Submit your request and we’ll contact you within an hour.
        </Text>
      )}
      <SelectorContainer
        items={eventsData}
        onSelect={props.onEventSelect}
        placeholder="Choose event"
        selectedItem={props.selectedEvent}
        isDisabled={props.isEventDisabled}
      />
      <SearchFromEventsDateTimeWrapper>
        <DatePicker
          // tslint:disable-next-line: no-magic-numbers
          maximumMonthsIndexes={5}
          onSelectDate={props.onDateSelect}
          selectedDate={props.selectedDate}
        />
        <SearchTime
          items={timeRange}
          onSelect={props.onTimeSelect}
          placeholder="Time"
          selectedTime={props.selectedTime}
        />
      </SearchFromEventsDateTimeWrapper>
      <Input
        type="email"
        inputStyle="round"
        placeholder="Email address"
        onChange={props.onEmailChange}
        value={props.email}
        required
      />
      <Textarea
        // tslint:disable-next-line: no-magic-numbers
        rows={3}
        placeholder="Please include the number of people, services, location and any other details."
        onChange={props.onNotesChange}
        value={props.notes}
        required
      />
      <SearchFromEventsButton type="submit" background="blue">
        Submit Request
      </SearchFromEventsButton>
      <SearchFromEventsTooltipWrapper>
        <TooltipPopoverContainer
          text="Please complete all of the fields and provide details of the number of people, location and services etc."
          isShow={props.isShowTooltip}
        />
      </SearchFromEventsTooltipWrapper>
    </SearchForm>
  );
};

export { SearchFormEvents };
